import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../global-config'
import { urlResolverGetAccountSubOrderDetailBySubOrderIdReturnLabelDocument } from '../../../../url-handling'
import { useContactPageLastOrderContext } from '../ContactPageLastOrderContext'

import { type ContactPageSelfServiceShortcutProps } from './ContactPageSelfServiceShortcutProps'

export const ContactPageSelfServiceShortcutReturnLabelCta: FC<
  ContactPageSelfServiceShortcutProps
> = () => {
  const config = useGlobalConfigContext()
  const { activeSubOrder, firstSubOrder, lastOrder } =
    useContactPageLastOrderContext()
  const subOrder = activeSubOrder ?? firstSubOrder
  const orderId = lastOrder?.orderMasterData?.orderNumber
  const { returnInfo, subOrderId } = subOrder ?? {}
  const returnLabel = returnInfo?.label
  const hasActiveReturnLabel = Boolean(returnLabel && !returnLabel.expired)
  const hasNoReturnShipments = !returnInfo?.shipments?.length

  if (
    !hasActiveReturnLabel ||
    !hasNoReturnShipments ||
    !orderId ||
    !subOrderId
  ) {
    return null
  }

  return (
    <Button<'a'>
      color="secondary"
      data-qa-id="form-return-label-btn"
      href={urlResolverGetAccountSubOrderDetailBySubOrderIdReturnLabelDocument(
        config,
        orderId,
        subOrderId,
      )}
      rel="noopener noreferrer"
      size="small"
      slots={{ root: 'a' }}
      target="_blank"
    >
      <FormattedMessage id="account.orders.returnLabel.confirmation.openReturnLabel" />
    </Button>
  )
}
